import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AxisPopup from "../../components/Devices/AxisPopup";
import { selectConfigAxes, selectShowAxisPopup, setShowAxisPopup } from "../../../Retrofit/store/slices/retrofit";

const SelectStep = () => {
  const dispatch = useDispatch();

  const configAxes = useSelector(selectConfigAxes);

  const showAxisPopup = useSelector(selectShowAxisPopup);

  useEffect(() => {
    if (configAxes.length > 1) {
      dispatch(setShowAxisPopup(false));
    }
  }, []);

  return showAxisPopup && <AxisPopup />;
};

export default SelectStep;
